import { makeStyles } from "@material-ui/core/styles";

import {
  h4Medium,
  h5Medium,
  h5Regular,
  h6Regular,
} from "../../shared/typography";

export const useFooterStyles = makeStyles({
  shell: {
    background: "#15222f",
    marginTop: 120,
    width: "100%",
    "@media screen and (max-width: 940px)": {
      marginTop: 56,
    },
  },
  root: {
    boxSizing: "border-box",
    color: "#ffffff",
    margin: "0 auto",
    maxWidth: 1600,
    padding: "120px clamp(40px, 5vw, 80px) 48px",
    "& *": {
      boxSizing: "border-box",
    },
    "@media screen and (min-width: 941px) and (max-width: 1180px)": {
      paddingLeft: 40,
      paddingRight: 40,
    },
    "@media screen and (max-width: 940px)": {
      padding: "72px 24px",
    },
    "@media screen and (max-width: 420px)": {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  main: {
    alignItems: "flex-start",
    columnGap: "clamp(48px, 6vw, 120px)",
    display: "grid",
    gridTemplateColumns:
      "auto minmax(150px, 220px) minmax(190px, 300px) minmax(190px, 1fr)",
    minHeight: 240,
    rowGap: 56,
    "@media screen and (min-width: 941px) and (max-width: 1180px)": {
      gridTemplateColumns: "auto minmax(160px, 1fr) minmax(190px, 1fr)",
    },
    "@media screen and (max-width: 940px)": {
      columnGap: 56,
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      minHeight: 0,
      rowGap: 48,
    },
    "@media screen and (max-width: 420px)": {
      columnGap: 32,
    },
  },
  brandLogo: {
    alignItems: "flex-start",
    display: "flex",
    "@media screen and (max-width: 940px)": {
      gridColumn: "1 / -1",
      "& svg": {
        height: 56,
        width: 64,
      },
    },
  },
  group: {
    display: "flex",
    flexDirection: "column",
  },
  help: {
    justifySelf: "end",
    minWidth: 0,
    "@media screen and (min-width: 941px) and (max-width: 1180px)": {
      gridColumn: "2 / -1",
      justifySelf: "start",
    },
    "@media screen and (max-width: 940px)": {
      gridColumn: "1 / -1",
      justifySelf: "stretch",
    },
  },
  title: {
    ...h5Medium,
    color: "#ffffff",
    display: "block",
    marginBottom: 32,
    "@media screen and (max-width: 940px)": {
      marginBottom: 24,
    },
  },
  links: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    "@media screen and (max-width: 940px)": {
      gap: 20,
    },
  },
  link: {
    ...h5Regular,
    color: "#ffffff",
    cursor: "pointer",
    opacity: 0.64,
    textDecoration: "none",
    "&:hover": {
      opacity: 0.8,
      textDecoration: "none",
    },
  },
  customerCareLink: {
    ...h5Regular,
    alignItems: "center",
    background: "transparent",
    border: 0,
    color: "#80bb34",
    cursor: "pointer",
    display: "flex",
    gap: 16,
    opacity: 1,
    padding: 0,
    textAlign: "inherit",
    "& span": {
      overflowWrap: "anywhere",
    },
    "&:hover": {
      opacity: 0.8,
    },
  },
  socials: {
    display: "none",
    "@media screen and (max-width: 940px)": {
      display: "flex",
      gap: 32,
      marginTop: 56,
    },
  },
  socialLink: {
    alignItems: "center",
    background: "#ffffff",
    border: 0,
    borderRadius: "50%",
    color: "#15222f",
    cursor: "pointer",
    display: "flex",
    fontFamily: "Barlow, Assistant",
    fontSize: 30,
    fontWeight: 700,
    height: 40,
    justifyContent: "center",
    lineHeight: 1,
    width: 40,
  },
  divider: {
    borderTop: "1px dashed rgba(255, 255, 255, 0.16)",
    margin: "64px 0 40px",
    "@media screen and (max-width: 940px)": {
      margin: "48px 0",
    },
  },
  bottom: {
    alignItems: "center",
    display: "grid",
    gap: 80,
    gridTemplateColumns: "minmax(260px, 1fr) auto",
    "@media screen and (max-width: 940px)": {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      gap: 56,
    },
  },
  mutedText: {
    ...h5Regular,
    color: "#ffffff",
    opacity: 0.64,
  },
  propertyLabel: {
    ...h6Regular,
    color: "#ffffff",
    opacity: 0.64,
  },
  property: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    "@media screen and (max-width: 940px)": {
      gap: 16,
    },
  },
  grasslandsLockup: {
    alignItems: "center",
    display: "flex",
    gap: 16,
  },
  grasslandsName: {
    ...h4Medium,
    color: "#ffffff",
    fontWeight: 700,
    opacity: 1,
  },
});
